import {Offer, OFFER_CATEGORIES} from '@chekin/core';

type OfferCategoryInput = Partial<Pick<Offer, 'category'>> | null | undefined;

type RequestedDealItem = {
  item: string;
  quantity: number;
};

const TIME_BASED_CATEGORIES = new Set<string>([
  OFFER_CATEGORIES.checkInCheckOut,
  OFFER_CATEGORIES.checkIn,
  OFFER_CATEGORIES.checkOut,
]);

export const isTimeBasedOffer = (offer?: OfferCategoryInput) =>
  Boolean(offer?.category && TIME_BASED_CATEGORIES.has(offer.category));

export const buildRequestedItemsForOffer = (
  offer: OfferCategoryInput,
  itemQuantities: Record<string, number>,
): {requestedItems: RequestedDealItem[]; numberOfPeople: number} => {
  const requestedItems = Object.entries(itemQuantities)
    .filter(([, qty]) => qty > 0)
    .map(([itemId, qty]) => ({
      item: itemId,
      quantity: qty,
    }));

  if (!isTimeBasedOffer(offer)) {
    return {
      requestedItems,
      numberOfPeople: requestedItems.reduce((sum, {quantity}) => sum + quantity, 0),
    };
  }

  const selectedItem = requestedItems[0];

  return {
    requestedItems: selectedItem ? [{item: selectedItem.item, quantity: 1}] : [],
    numberOfPeople: selectedItem ? 1 : 0,
  };
};
